import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody, CardTitle, Button, Alert} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone,} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import NewModal from "./NewModal";
import DeleteModal from "./DeleteModal";
import GroupPermissionsModal from "./Permissions/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {groupsList} from "../../store/groups/actions";
import {connect} from "react-redux";
import SelectModal from "../../components/Common/SelectModal";
import {get, patch} from "../../api/api";
import {format} from "react-string-format";
import * as url from "../../api/url";
import {apiGetUsersList} from "../../api/calls/groups";

class Groups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupsData: [],
      loading: false,
      error: "",
      groupData: null,
      newModal: false,
      deleteModal: false,
      permissionsModal: false,
      usersModal: false,
    }
    this.refresh = this.refresh.bind(this)
    this.togNew = this.togNew.bind(this)
    this.togDelete = this.togDelete.bind(this)
    this.togPermissions = this.togPermissions.bind(this)
    this.togUsers = this.togUsers.bind(this)
    this.apiGetGroupUsersSelected = this.apiGetGroupUsersSelected.bind(this)
    this.apiPatchGroupsUpdate = this.apiPatchGroupsUpdate.bind(this)
  }

  componentDidMount() {
    this.refresh()
  }

  refresh() {
    this.props.onGroupsList({history: this.props.history})
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        groupsData: this.props.response.response ? this.props.response.response : [],
        loading: this.props.loading,
        error: this.props.error
      });
    }
  }

  togNew(data = null, action) {
    this.setState(prevState => ({
      action: action,
      groupData: data,
      newModal: !prevState.newModal,
    }))
  }

  togDelete(data = null) {
    this.setState(prevState => ({
      groupData: data,
      deleteModal: !prevState.deleteModal,
    }))
  }

  togPermissions(data = null) {
    this.setState(prevState => ({
      groupData: data,
      permissionsModal: !prevState.permissionsModal,
    }))
  }

  togUsers(data = null) {
    this.setState(prevState => ({
      selectData: data,
      usersModal: !prevState.usersModal,
    }))
  }

  apiGetGroupUsersSelected = data => {
    return get(format(url.API_GROUPS_DETAIL, this.state.selectData.id) + "users/", this.props.history)
  }

  apiPatchGroupsUpdate = data => {
    return patch(format(url.API_GROUPS_DETAIL, this.state.selectData.id), this.props.history, {users: data.selectedRows})
  }

  render() {
    const actionFormatter = (cell, row) => {
      return (<div>
        <Button color="info" className="me-2 mb-2" onClick={() => this.togUsers({id: row.id, name: row.name})}>Users</Button>
        <Button color="info" className="me-2 mb-2" onClick={() => this.togPermissions({id: row.id, name: row.name})}>Permissions</Button>
        <Button color="success" className="me-2 mb-2" onClick={() => this.togNew({id: row.id, name: row.name}, "edit")}>Edit</Button>
        {!row.is_fixed && <Button color="danger" className="me-2 mb-2" onClick={() => this.togDelete({id: row.id, name: row.name})}>Delete</Button>}
      </div>);
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "name", text: "Name", sort: true,
    }, {
      dataField: "created", text: "Created", sort: true,
    }, {
      dataField: "", text: "Actions", sort: true, formatter: actionFormatter,
    },];

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.groupsData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.name.toLowerCase().includes(searchText) || row.created.includes(searchText))
        return true
      return false
    }

    document.title = "Groups | FileJet";

    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={this.props.t("FileJet")}
            breadcrumbItem={this.props.t("Groups")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={this.state.groupsData}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={this.state.groupsData}
                      search={{onColumnMatch}}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col md="8">
                            <div>
                              <Button color="primary" onClick={() => this.togNew({}, "new")}>
                                New
                              </Button>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {this.state.loading && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {this.state.error.length > 0 && (<div className="mt-3">
                    <Alert color="danger" role="alert">
                      {this.state.error}
                    </Alert>
                  </div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.newModal && <NewModal action={this.state.action} togModal={this.togNew} refreshParent={this.props.onGroupsList} groupData={this.state.groupData} history={this.props.history}/>}
          {this.state.deleteModal && <DeleteModal togModal={this.togDelete} refreshParent={this.props.onGroupsList} groupData={this.state.groupData} history={this.props.history}/>}
          {this.state.permissionsModal && <GroupPermissionsModal togModal={this.togPermissions} groupData={this.state.groupData} history={this.props.history}/>}
          {this.state.usersModal &&
            <SelectModal togModal={this.togUsers}
                         refreshParent={this.refresh}
                         title="Select users"
                         apiList={apiGetUsersList}
                         apiSelected={this.apiGetGroupUsersSelected}
                         apiUpdate={this.apiPatchGroupsUpdate}
                         selectData={this.state.selectData}
                         history={this.props.history}/>}
        </Container>
      </div>
    </React.Fragment>);
  }
}

Groups.propTypes = {
  response: PropTypes.any,
  onGroupsList: PropTypes.func,
};

const mapStateToProps = ({Groups}) => ({
  response: Groups.responseList,
  loading: Groups.loadingList,
  error: Groups.errorList,
});

const mapDispatchToProps = dispatch => ({
  onGroupsList: data => dispatch(groupsList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Groups));
